// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/learning/ConfidenceTrendCard.jsx

import React from 'react';

const pct = (value) => {
  const n = Number(value);
  if (Number.isNaN(n)) return '—';
  const normalized = n <= 1 ? n * 100 : n;
  return `${normalized.toFixed(0)}%`;
};

export default function ConfidenceTrendCard({ confidence = {} }) {
  const direction = confidence?.direction || 'unchanged';
  const directionClass = direction === 'increased'
    ? 'learning-confidence-up'
    : direction === 'reduced'
      ? 'learning-confidence-down'
      : 'learning-confidence-flat';

  return (
    <section className="learning-card confidence-trend-card">
      <div className="learning-card-header">
        <div>
          <p className="learning-eyebrow">Confidence Evolution</p>
          <h4>Dynamic Confidence</h4>
        </div>
        <span className={`learning-status-pill ${directionClass}`}>{direction}</span>
      </div>

      <div className="learning-confidence-row">
        <div>
          <span>Base</span>
          <strong>{pct(confidence?.base_confidence)}</strong>
        </div>
        <div className="learning-confidence-arrow">→</div>
        <div>
          <span>Adjusted</span>
          <strong>{pct(confidence?.adjusted_confidence)}</strong>
        </div>
      </div>

      <div className="learning-callout">
        <span>Delta</span>
        <p>{pct(confidence?.delta)} · {confidence?.advisory_only ? 'Advisory only — no automatic changes.' : 'Review required.'}</p>
      </div>

      {Array.isArray(confidence?.reasons) && confidence.reasons.length > 0 ? (
        <ul className="learning-list">
          {confidence.reasons.map((reason) => <li key={reason}>{reason}</li>)}
        </ul>
      ) : null}
    </section>
  );
}
